/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Send_Test_NotificationInputs */

const th_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งการแจ้งเตือนทดสอบ`)
};

const en_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a test notification`)
};

const ja_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト通知を送る`)
};

const zh_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送测试通知`)
};

const es_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar una notificación de prueba`)
};

const pt_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar uma notificação de teste`)
};

const id_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim notifikasi uji`)
};

const fr_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer une notification de test`)
};

const tl_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magpadala ng pansubok na notipikasyon`)
};

const vi_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi thông báo thử`)
};

const ko_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테스트 알림 보내기`)
};

const de_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testbenachrichtigung senden`)
};

const ru_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить тестовое уведомление`)
};

const tr_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test bildirimi gönder`)
};

const it_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia una notifica di prova`)
};

const pl_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij powiadomienie testowe`)
};

const uk_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надіслати тестове сповіщення`)
};

const hi_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण सूचना भेजें`)
};

const ar_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال إشعار تجريبي`)
};

const ms_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar pemberitahuan ujian`)
};

const bn_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরীক্ষামূলক বিজ্ঞপ্তি পাঠান`)
};

const zh_tw2_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄出測試通知`)
};

const zh_hk2_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄出測試通知`)
};

const ur_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آزمائشی اطلاع بھیجیں`)
};

const fa_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرستادن اعلان آزمایشی`)
};

const sw_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuma arifa ya majaribio`)
};

const nl_send_test_notification = /** @type {(inputs: Send_Test_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testmelding versturen`)
};

/**
* | output |
* | --- |
* | "Send a test notification" |
*
* @param {Send_Test_NotificationInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const send_test_notification = /** @type {((inputs?: Send_Test_NotificationInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Send_Test_NotificationInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_send_test_notification(inputs)
	if (locale === "ja") return ja_send_test_notification(inputs)
	if (locale === "zh") return zh_send_test_notification(inputs)
	if (locale === "es") return es_send_test_notification(inputs)
	if (locale === "pt") return pt_send_test_notification(inputs)
	if (locale === "id") return id_send_test_notification(inputs)
	if (locale === "fr") return fr_send_test_notification(inputs)
	if (locale === "tl") return tl_send_test_notification(inputs)
	if (locale === "vi") return vi_send_test_notification(inputs)
	if (locale === "ko") return ko_send_test_notification(inputs)
	if (locale === "de") return de_send_test_notification(inputs)
	if (locale === "ru") return ru_send_test_notification(inputs)
	if (locale === "tr") return tr_send_test_notification(inputs)
	if (locale === "it") return it_send_test_notification(inputs)
	if (locale === "pl") return pl_send_test_notification(inputs)
	if (locale === "uk") return uk_send_test_notification(inputs)
	if (locale === "hi") return hi_send_test_notification(inputs)
	if (locale === "ar") return ar_send_test_notification(inputs)
	if (locale === "ms") return ms_send_test_notification(inputs)
	if (locale === "bn") return bn_send_test_notification(inputs)
	if (locale === "zh-TW") return zh_tw2_send_test_notification(inputs)
	if (locale === "zh-HK") return zh_hk2_send_test_notification(inputs)
	if (locale === "ur") return ur_send_test_notification(inputs)
	if (locale === "fa") return fa_send_test_notification(inputs)
	if (locale === "sw") return sw_send_test_notification(inputs)
	if (locale === "nl") return nl_send_test_notification(inputs)
	return en_send_test_notification(inputs)
});